export default __webpack_public_path__ + "static/media/KhuuTuanInterior.e223b9b2.png";